module.exports = __webpack_public_path__ + "img/search.a970ac65.png";